import { View } from '@react-pdf/renderer';
import React from 'react';
import Page from '../../components/Page';
import type { Collection, MyListPageItem } from './MyList';
import Footer from './MyList.Footer';
import Halfpage from './MyList.Halfpage';
import { Text } from './Text';

export default function TastingBookletPage({
  items,
  collection,
  bleed = 0,
  style,
  ...rest
}: {
  items: MyListPageItem[];
  collection: Collection;
  bleed?: number;
  style?: any;
}) {
  const page1Item = items[0];
  const page2Item = items[1];

  return (
    <Page
      size="A4"
      style={[
        { paddingVertical: `${bleed}mm`, paddingHorizontal: `${bleed}mm` },
        style,
      ]}
      {...rest}
    >
      <Halfpage item={page1Item} collection={collection} />
      <FoldLine />
      {page2Item ? (
        <Halfpage item={page2Item} collection={collection} />
      ) : (
        <View style={{ height: '148mm' }} />
      )}
      <Footer collection={collection} />
    </Page>
  );
}
function FoldLine() {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        position: 'absolute',
        top: '146mm',
        left: 0,
        right: 0,
      }}
    >
      <View
        style={{
          borderBottom: 1,
          borderColor: '#ccc',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
        }}
      />
      <Text style={{ color: '#ccc', marginHorizontal: 5, fontSize: 10 }}>
        Fold here
      </Text>
      <View
        style={{
          borderBottom: 1,
          borderColor: '#ccc',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
        }}
      />
    </View>
  );
}
